export const mapSwitchStyles = (theme, { size, disabled }) => {
  const sizeStyles = {
    sm: {
      width: 36,
      height: 20,
      '& .MuiSwitch-thumb': {
        width: 18,
        height: 18
      },
      '& .MuiSwitch-switchBase': {
        padding: 1,
        '&.Mui-checked': {
          transform: 'translateX(16px)'
        }
      }
    },
    lg: {
      width: 50,
      height: 26,
      '& .MuiSwitch-thumb': {
        width: 24,
        height: 24
      },
      '& .MuiSwitch-switchBase': {
        padding: 1,
        '&.Mui-checked': {
          transform: 'translateX(26px)'
        }
      }
    }
  }

  return {
    ...sizeStyles[size || 'lg'],
    padding: 0,
    '& .MuiSwitch-switchBase': {
      ...sizeStyles[size || 'lg']['& .MuiSwitch-switchBase'],
      color: 'var(--color-neutral-050)',
      '&.Mui-checked': {
        ...sizeStyles[size || 'lg']['& .MuiSwitch-switchBase']['&.Mui-checked'],
        color: 'var(--color-neutral-050)',
        '& + .MuiSwitch-track': {
          backgroundColor: 'var(--color-success-500)',
          opacity: 1,
          border: 'none'
        }
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: 'var(--color-success-500)',
        border: '6px solid #fff'
      },
      '&.Mui-disabled': {
        color: 'var(--color-neutral-300)',
        '& + .MuiSwitch-track': {
          backgroundColor: 'var(--color-neutral-200)',
          opacity: 0.5
        }
      }
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      border: 'var(--border-neutral-thin)',
      backgroundColor: 'var(--color-neutral-200)',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border'])
    },
    ...(disabled && {
      opacity: 0.6,
      cursor: 'not-allowed'
    })
  }
}
